import * as React from 'react'
import { FC } from 'react'
import { Field, useField } from 'formik'
import { IFilterProps, Nullable } from '../typings'
import CollapsibleFilter from './atoms/CollapsibleFilter'

import Grid from '@mui/material/Grid'
import MenuItem from '@mui/material/MenuItem'
import { MuiTextFieldFormik } from '@user/components/Formik'

interface Props extends IFilterProps {
  nullLabel: string
  notNullLabel: string
  emptyLabel: string
}

export const NullableFilter: FC<Props> = ({
  name,
  label,
  nullLabel,
  notNullLabel,
  emptyLabel,
  reset,
}) => {
  const path = `filters.${name}.value`

  const [{ value }] = useField<Nullable>(path)

  const subLabel = React.useMemo(
    () =>
      value === 'null' ? nullLabel : value === 'notnull' ? notNullLabel : '',
    [notNullLabel, nullLabel, value],
  )

  return (
    <CollapsibleFilter
      label={label}
      subLabel={(expanded) => !expanded && subLabel}
      reset={reset}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Field
            name={path}
            component={MuiTextFieldFormik}
            select
            size="small"
            fullWidth
          >
            <MenuItem value="empty">{emptyLabel}</MenuItem>
            <MenuItem value="notnull">{notNullLabel}</MenuItem>
            <MenuItem value="null">{nullLabel}</MenuItem>
          </Field>
        </Grid>
      </Grid>
    </CollapsibleFilter>
  )
}
NullableFilter.displayName = 'NullableFilter'
